import { Injectable, NgZone, isDevMode } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { Observer } from 'rxjs/Observer';
import { Observable } from 'rxjs/Observable';
import { AutheticationService } from './authetication.service';
import { Router } from '@angular/router';
import { StateService } from './state.service';
import { MatDialog } from '@angular/material';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import getToken from '@app/utils/get-token';

@Injectable()
export class WsService {
  socket$: Subscription;
  message: Subject<any> = new Subject();
  onOpen: Subject<boolean> = new Subject();
  activeSubs = [];

  private wsSubject: Subject<any>;
  private url: string;
  private urlRaw: string;
  private PingTimer;
  wsSendTime;
  private subIds = [];

  constructor(
    private auth: AutheticationService,
    private zone: NgZone,
    private state: StateService,
    protected router: Router,
    private dialog: MatDialog,
    private cookieService: CookieService
  ) {}

  public send(msg) {
    this.wsSubject.next(msg);
    return getToken(this.cookieService);
  }

  public createSub(subs) {
    this.activeSubs.push(...subs);
    let args = {};
    subs
      .filter(el => el.args)
      .map(sub => {
        args[sub.name] = sub.args;
      });
    this.send({
      header: {
        type: 'sub',
        action: 'set'
      },
      data: {
        subscriptions: subs.map(sub => sub.name),
        arguments: args
      }
    });
  }

  public closeSub(subs) {
    this.activeSubs = this.activeSubs.filter(el => !subs.find(sub => sub.name != el.name));
    let args = {};
    subs
      .filter(el => el.args)
      .map(sub => {
        args[sub.name] = sub.args;
      });
    if (subs.length) {
      this.send({
        header: {
          type: 'sub',
          action: 'cancel'
        },
        data: {
          subscriptions: subs.map(sub => sub.name),
          arguments: args
        }
      });
    }
  }



  public close(): void {
    this.socket$.unsubscribe();
    this.wsSubject.complete();
  }

  create(url, switchServer = false): void {
    this.urlRaw = switchServer
      ? `${environment.config.ws}${environment.config.domain}/${environment.config.client}/${url}`
      : url;
    this.url = this.urlRaw + getToken(this.cookieService);
    let ws = new WebSocket(this.url);
    let observable = new Observable((observerWS: Observer<MessageEvent>) => {
      ws.onmessage = observerWS.next.bind(observerWS);
      ws.onerror = observerWS.error.bind(observerWS);
      ws.onclose = observerWS.complete.bind(observerWS);
      return ws.close.bind(ws);
    });

    let observer = {
      next: data => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify(data));
        } else if (ws.readyState === 0) {
          this.zone.runOutsideAngular(() => {
            setTimeout(() => {
              this.send(data);
            }, 3000);
          });
        }
      }
    };

    this.wsSubject = Subject.create(observer, observable);

    this.socket$ = this.wsSubject.subscribe({
      next: data => {
        if (JSON.parse(data.data).header.type.toLowerCase() == 'err') {
          console.log('ws', JSON.parse(data.data));
          if (JSON.parse(data.data).header.status == 'UNAUTHORIZED') {
            this.auth.logOut();
            this.router.navigateByUrl('/login');
            this.dialog.closeAll();
          }
        } else {
          let sub = JSON.parse(data.data).header;
          if (sub.type == 'counter' && !this.subIds.find(el => el.sub_id == sub.sub_id)) {
            this.subIds.push(sub);
          }
          this.message.next(data.data);
          this.onOpen.next(true);
        }
      },
      error: err => {
        console.error(err);
        this.onOpen.next(false);
        clearInterval(this.PingTimer);
        setTimeout(() => {
          this.create(this.urlRaw);
          this.createSub([
            {
              name: 'req',
              args: {
                interval: 300
              }
            }
          ]);
        }, 5000);
        this.socket$.unsubscribe();
        // this.message.next( { header: { 'type': 'error' } } );
      },
      complete: () => {
        this.onOpen.next(false);
        console.log('close');
        console.log(this.state.getParameter('authStatus'));
        if (this.state.getParameter('authStatus') == true) {
          this.zone.runOutsideAngular(() => {
            setTimeout(() => {
              console.log('recconect');
              this.create(this.urlRaw);
              this.createSub([
                {
                  name: 'req',
                  args: {
                    interval: 300
                  }
                }
              ]);
            }, 5000);
          });
        } else {
          this.router.navigate(['/login']);
        }
      }
    });

    this.zone.runOutsideAngular(() => {
      this.PingTimer = setInterval(() => {
        this.wsSendTime = new Date().getTime();
        this.wsSubject.next({
          header: {
            type: 'ping'
          }
        });
      }, 10000);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/ws.service.ts